import request from '@/utils/request'

// 颜色主表API
export const getColors = (params) => {
  return request({
    url: '/api/colors',
    method: 'get',
    params
  })
}

export const createColor = (data) => {
  return request({
    url: '/api/colors',
    method: 'post',
    data
  })
}

export const updateColor = (id, data) => {
  return request({
    url: `/api/colors/${id}`,
    method: 'put',
    data
  })
}

export const deleteColor = (id) => {
  return request({
    url: `/api/colors/${id}`,
    method: 'delete'
  })
}

export const toggleColorStatus = (id, data) => {
  return request({
    url: `/api/colors/${id}/status`,
    method: 'patch',
    data
  })
}

// 颜色详情表API
export const getColorDetails = (colorId) => {
  return request({
    url: `/api/colors/${colorId}/details`,
    method: 'get'
  })
}

export const createColorDetail = (colorId, data) => {
  return request({
    url: `/api/colors/${colorId}/details`,
    method: 'post',
    data
  })
}

export const updateColorDetail = (colorId, detailId, data) => {
  return request({
    url: `/api/colors/${colorId}/details/${detailId}`,
    method: 'put',
    data
  })
}

export const deleteColorDetail = (colorId, detailId) => {
  return request({
    url: `/api/colors/${colorId}/details/${detailId}`,
    method: 'delete'
  })
}

// 下载颜色导入模板
export const downloadColorImportTemplate = () => {
  return request({
    url: '/api/colors/import-template',
    method: 'get',
    responseType: 'blob'
  })
}

// 批量导入颜色
export const importColors = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/colors/import',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 清空所有颜色数据
export const clearAllColors = (operationPassword) => {
  return request({
    url: '/api/colors/clear-all?confirm=true',
    method: 'delete',
    headers: {
      'X-Operation-Password': operationPassword,
    },
  })
}

// 重新关联颜色数据
export const reassociateColors = (matchBy = 'name_en') => {
  return request({
    url: '/api/colors/reassociate',
    method: 'post',
    data: { match_by: matchBy }
  })
}

// 重置color ID
export const resetColorId = (operationPassword) => {
  return request({
    url: '/api/colors/reset-id',
    method: 'post',
    data: { operation_password: operationPassword },
  })
}

// 批量匹配颜色
export const matchColorsBatch = (colorList) => {
  return request({
    url: '/api/colors/match-batch',
    method: 'post',
    data: { color_list: colorList },
    timeout: 120000 // 120秒超时，用于处理大量数据
  })
}